const OBSERVER_OPTIONS = {
  rootMargin: '-20% 0px',
};

const handlerIntersection = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('animation-active');
      entry.target.classList.remove('animation-out');
    } else {
      entry.target.classList.remove('animation-active');
      entry.target.classList.add('animation-out');
    }
  });
};

const initFunctionalityAnimation = (wrapper) => {
  if (!wrapper) {
    return;
  }

  const animationObserver = new IntersectionObserver(
      handlerIntersection,
      OBSERVER_OPTIONS
  );

  wrapper.classList.add('js-active');
  animationObserver.observe(wrapper);
};

export {initFunctionalityAnimation};
